import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { Award, Check, Lock } from "lucide-react";

import SidebarLayout from "@/components/SidebarLayout";
import { api } from "@/lib/api";


const TIER_COLOR = {
    bronze: "#A3A3A3",
    silver: "#B5B8BF",
    gold: "#A3A3A3",
    platinum: "#CCCCCC",
};


export default function CivilizationBadges() {
    const [all, setAll] = useState([]);
    const [mine, setMine] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        (async () => {
            try {
                const [a, m] = await Promise.all([
                    api.civilizationBadges(),
                    api.civilizationMyBadges(),
                ]);
                setAll(a.items || []);
                setMine((m.items || []).map((b) => b.badge_slug));
            } catch (e) {
                toast.error(e.message || "Failed to load badges");
            } finally {
                setLoading(false);
            }
        })();
    }, []);

    return (
        <SidebarLayout>
            <div className="max-w-5xl mx-auto py-6 px-2">
                <h1 className="text-2xl font-semibold">All badges</h1>
                <p className="text-sm text-text-secondary">
                    {mine.length}/{all.length} sbloccati. Rilevati via cron ogni ora + eventi realtime.
                </p>

                {loading ? (
                    <p className="mt-8 text-sm text-text-secondary">Loading…</p>
                ) : (
                    <div
                        data-testid="badges-catalog"
                        className="mt-6 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3"
                    >
                        {all.map((b) => {
                            const owned = mine.includes(b.slug);
                            const c = TIER_COLOR[b.tier] || "#CCCCCC";
                            return (
                                <div
                                    key={b.id}
                                    data-testid={`badge-item-${b.slug}`}
                                    className={`rounded-2xl border p-4 transition ${
                                        owned
                                            ? "border-[var(--color-success)]/40 bg-[var(--color-success)]/5"
                                            : "border-[var(--color-border)] bg-[var(--color-card)] opacity-90"
                                    }`}
                                >
                                    <div className="flex items-center gap-3">
                                        <div
                                            className="h-12 w-12 rounded-xl grid place-items-center shrink-0"
                                            style={{ background: `${c}22`, color: c }}
                                        >
                                            {owned ? <Award className="h-6 w-6" /> : <Lock className="h-5 w-5" />}
                                        </div>
                                        <div className="min-w-0 flex-1">
                                            <p className="font-semibold truncate">{b.name}</p>
                                            <p
                                                className="mt-0.5 text-[10px] uppercase tracking-widest"
                                                style={{ color: c }}
                                            >
                                                {b.tier} · +{b.points_value} pts
                                            </p>
                                        </div>
                                        {owned && (
                                            <Check className="h-4 w-4 text-[var(--color-success)]" />
                                        )}
                                    </div>
                                    <p className="mt-3 text-xs text-text-secondary leading-relaxed">
                                        {b.description}
                                    </p>
                                    {b.is_era_specific && (
                                        <p className="mt-2 text-[10px] uppercase tracking-widest text-[var(--color-secondary)]">
                                            Era-specific
                                        </p>
                                    )}
                                </div>
                            );
                        })}
                    </div>
                )}
            </div>
        </SidebarLayout>
    );
}
